// Smart Daara - Legacy Tenant Redirect
// Redirects legacy unslugged paths (e.g. /school, /student) to their
// slug-prefixed equivalent based on the authenticated user's tenant.

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const TenantRedirect = () => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-2 border-emerald-600 border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Super admin doesn't use slugged URLs
  if (user?.role === 'super_admin') {
    return <Navigate to="/admin" replace />;
  }

  const slug = user?.tenant_slug;
  if (!slug) {
    // No slug means we can't build the tenant-scoped URL; fall back to login
    return <Navigate to="/login" replace />;
  }

  // Preserve the sub-path (e.g. /school/classes -> /:slug/school/classes)
  const target = `/${slug}${location.pathname}${location.search || ''}`;
  return <Navigate to={target} replace />;
};

export default TenantRedirect;
